import type {RouteRecordRaw} from "vue-router";
import {localeUrlPattern} from "@/shared/lib/i18n";
import {applyUrlLocale} from "./applyUrlLocale";
import {routeName as mainName} from "./main";

export const routeName = 'LocaleRedirect';

export const route: RouteRecordRaw = {
    name: routeName,
    // /kk, /ru, /en — языковой вариант главной для шаринга: путь кэшируется, ?lang= — нет
    path: `/:lang(${localeUrlPattern})`,
    redirect: (to) => {
        applyUrlLocale(to.params.lang);
        return {name: mainName};
    },
};
